"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var instance = axios_1.default.create({
    timeout: 30000
});
// instance.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
instance.defaults.withCredentials = true;
instance.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
instance.defaults.headers.post['Content-Type'] = 'application/json';
// instance.defaults.baseURL = "api.example.com"
instance.interceptors.request.use(function (config) {
    return config;
}, function (err) {
    return Promise.reject(err);
});
instance.interceptors.response.use(function (response) {
    if (response.status === 200) {
        return Promise.resolve(response);
    }
    else {
        return Promise.reject(response);
    }
}, function (error) {
    switch (error.response.status) {
        case 401:
            console.log('401 Error');
            break;
        case 403:
            console.log('403 Error');
            break;
        case 404:
            console.log('404 Error');
            break;
        case 500:
            console.log('500 Error');
            break;
        default:
            console.log('其他錯誤訊息');
    }
    return Promise.reject(error);
});
exports.default = instance;
